<template>
  <div class="fr-ac">
    <div
      class="fs-16 mr-8"
      :style="currentValue ? 'color: var(--text-color-primary);' : ''"
      v-if="title"
    >
      {{ title }}
    </div>
    <el-switch
      v-model="currentValue"
      :size="size"
      :style="switchStyle"
      :disabled="disabled"
      @change="handleChange"
      :before-change="beforeChange"
    >
      <template #active-action>
        <div class="switch-active-line"></div>
      </template>
      <template #inactive-action>
        <div class="switch-line"></div>
      </template>
    </el-switch>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, toRefs } from 'vue';

// 定义 props 类型
// interface Props {
//     size?: string;
//     modelValue?: boolean;
//     activeColor?: string;
//     inactiveColor?: string;
//     disabled?: boolean;
//     beforeChange?: () => boolean;
// }

const props = defineProps({
  modelValue: Boolean,
  size: { type: String, default: 'large' },
  activeColor: { type: String, default: 'var(--text-color-primary)' },
  inactiveColor: { type: String, default: '#cccccc' },
  disabled: { type: Boolean, default: false },
  beforeChange: { type: Function, default: () => true },
  title: { type: String, default: '' },
});

// 使用 withDefaults 设置默认值
// const props = withDefaults(defineProps<Props>(), {
//     size: 'large',
//     modelValue: false,
//     activeColor: '#A065FF',
//     inactiveColor: '#cccccc',
//     disabled: false
// });

const emit = defineEmits(['update:modelValue', 'change']);

const { size, activeColor, inactiveColor, disabled } = toRefs(props);

const currentValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

// 使用 computed 来动态计算开关的样式
const switchStyle = computed(() => {
  return {
    '--el-switch-on-color': activeColor.value,
    '--el-switch-off-color': inactiveColor.value,
  };
});

const handleChange = (value: boolean) => {
  emit('change', value);
  // emit("update:modelValue", value);
};

// 监听 currentValue 的变化，发送事件到父组件同步状态
// watch(currentValue, (newValue) => {
//     emit("update:modelValue", newValue);
// });
</script>

<style scoped lang="scss">
.switch-line {
  /* 自定义关闭时的样式 */
  width: 2px;
  height: 8px;
  background-color: #cccccc;
  border-radius: var(--border-radius);
}

.switch-active-line {
  /* 自定义开启时的样式 */
  width: 2px;
  height: 8px;
  background-color: #a065ff;
  border-radius: var(--border-radius);
}
</style>
